const state = {
    loggedInUser: {},
    currentUser: {},
    lastVisitedSlug: '',
    userListDialog: {
        isVisible: false,
        users: []
    },
    preferences: {
        showSensitive: false,
        theme: 'dark',
        scheme: 'banana',
        language: 'en',
        timeline: 'uploadTime',
        order: 'desc',
        cookies: null
    }
}

export default state